const siteInfo =
  process.env.NEXT_PUBLIC_STATAMIC_SITE_HANDLE === 'blink'
    ? {
        orgName: 'Blink AG',
        locationName: (location: string) => `BLINK Fahrschule - ${location}`,
        sidebarName: (location: string) => `BLINK Fahrschule ${location}`,
      }
    : process.env.NEXT_PUBLIC_STATAMIC_SITE_HANDLE === 'nohe'
      ? {
          orgName: 'nohe by BLINK',
          locationName: (location: string) => `nohe by BLINK - ${location}`,
          sidebarName: (location: string) =>
            `nohe by BLINK | Nothelferkurse ${location}`,
        }
      : {
          orgName: 'fahrlehrer.ch',
          locationName: (location: string) => `fahrlehrer.ch - ${location}`,
          sidebarName: (location: string) =>
            `fahrlehrer.ch | Fahrschule ${location}`,
        }

const getBusinessType = (_fullUrl: string) => {
  return 'LocalBusiness'
  // if (fullUrl.toLowerCase().includes('fahrschule')) {
  //   return 'DrivingSchool'
  // } else {
  //   return 'LocalBusiness'
  // }
}

export default siteInfo
export { getBusinessType }
